import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL + "/Enrollment/";

export function getEnrollee(ClientID, UserID) {
  return apiUtils
    .get(`${baseUrl}Load?ClientID=${ClientID}&UserID=${UserID}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function clientSave(saveObj) {
  let portalID = { portalID: 3 };
  let newSaveObj = { ...saveObj, ...portalID };
  return apiUtils
    .post(`${baseUrl}ClientSave`, newSaveObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function updateClient(client) {
  let portalID = { portalID: 3 };
  let newUpdateObj = { ...client, ...portalID };
  return apiUtils
    .put(`${baseUrl}ClientUpdate`, newUpdateObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function updateEnrollee(updateObj) {
  let webUserName = { webUserName: "ClientEnrollment" };
  let newUpdateObj = { ...updateObj, ...webUserName };
  return apiUtils
    .put(`${baseUrl}EnrolleeUpdate`, newUpdateObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function scheduleEnrollee(enrollee) {
  return (
    apiUtils
      .put(baseUrl + enrollee.clientId, enrollee)
      //.put(`${baseUrl}ScheduleEnrollee`, enrollee)
      .then(apiUtils.handleResponse)
      .catch(apiUtils.handleError)
  );
}

export function resetProfilePassword(userID, password) {
  return apiUtils
    .post(`${process.env.API_URL}/Users/ResetUserPassword`, {
      userID,
      password,
    })
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getIDData(userId, file) {
  let readerUrl = process.env.API_URL + "/BarCodeReader/";

  return apiUtils
    .postMulti(`${readerUrl}ReadDriverLicense?userId=${userId}`, file)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function pickBackUpEnrollment(token, BrandIdentifier) {
  return apiUtils
    .get(
      `${baseUrl}ContinueEnrollment/${encodeURIComponent(token)}?BrandIdentifier=${encodeURIComponent(BrandIdentifier)}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

// export function validateEnrollmentCode(EnrollmentCode, BrandIdentifier) {
//   return apiUtils
//     .get(
//       `${baseUrl}ValidateCode?EnrollmentCode=${EnrollmentCode}&BrandIdentifier=${BrandIdentifier}`
//     )
//     .then(apiUtils.handleResponse)
//     .catch(apiUtils.handleError);
// }

export function validateEnrollmentCode(EnrollmentCode, BrandIdentifier) {
  return apiUtils
    .get(
      `${baseUrl}ValidateCode/${EnrollmentCode}?BrandIdentifier=${BrandIdentifier}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function textOptIn(optInObj) {
  return apiUtils
    .post(`${baseUrl}SMSOptIn`, optInObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
/**
 *
 * @param {string} State
 * @param {string} EnrollmentCodeType
 * @param {string} BrandIdentifier
 * @returns {string} - the enrollment code or an error
 */
export function getEnrollmentCodeStateDefaultByType(
  State,
  EnrollmentCodeType,
  BrandIdentifier
) {
  return apiUtils
    .get(
      `${baseUrl}GetEnrollmentCodeStateDefaultByType?State=${State}&EnrollmentCodeType=${EnrollmentCodeType}&BrandIdentifier=${BrandIdentifier}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getIsaEnrollmentCodeByState(
  State,
  BrandIdentifier
) {
  return apiUtils
    .get(
      `${baseUrl}GetISAEnrollmentCodeByState?State=${State}&BrandIdentifier=${BrandIdentifier}`
    )
    .then(async (response) => {
      if ([400, 404].includes(response.status)) {
        const responseBody = await response.text();
        const error = new Error(responseBody || response.statusText);
        error.status = response.status;
        throw error;
      }
      return apiUtils.handleResponse(response);
    })
    .catch(apiUtils.handleError);
}

export function registerEnrollee(obj) {
  const enrolleeObj = { ...obj, version: "V2" };
  return apiUtils
    .post(`${baseUrl}EnrolleeRegister`, enrolleeObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function validateCode(enrollmentCode, brandIdentifier) {
  return apiUtils
    .get(
      `${baseUrl}ValidateCode/${enrollmentCode}?BrandIdentifier=${brandIdentifier}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getClientCheck(
  FirstName,
  LastName,
  CellPhone,
  Email,
  BrandIdentifier
) {
  return apiUtils
    .get(
      `${baseUrl}ClientCheck?FirstName=${FirstName}&LastName=${LastName}&CellPhone=${CellPhone}&Email=${Email}&BrandIdentifier=${BrandIdentifier}`
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function clientCheck(clientObj) {
  return apiUtils
    .post(`${baseUrl}ClientCheck`, clientObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function clientProfiles(clientId) {
  return apiUtils
    .get(`${process.env.API_URL}/ClientProfiles/${clientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function five9Text(clientObj) {
  return apiUtils
    .post(`${baseUrl}Five9Text`, clientObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function generatePriceQuote(quoteObj) {
  return apiUtils
    .post(`${baseUrl}GeneratePriceQuote`, quoteObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getPriceQuoteDetails(priceQuoteGuid) {
  return apiUtils
    .get(
      `${process.env.API_URL}/Appointments/GetPriceQuoteDetails?priceQuoteGuid=${priceQuoteGuid}`,
    )
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function saveClientQuestionResponse(questionObj) {
  return apiUtils
    .post(`${baseUrl}SaveClientQuestionResponse`, questionObj)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getClientQuestionResponse(clientId) {
  return apiUtils
    .get(`${baseUrl}ClientQuestionResponse/${clientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function quietHours(clientId){
  return apiUtils
    .get(`${baseUrl}GetQuiteHours/${clientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
